import { render } from "./PdfViewerPage.vue?vue&type=template&id=7ca2e5cc&ts=true"
import script from "./PdfViewerPage.vue?vue&type=script&lang=ts"
export * from "./PdfViewerPage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__